import { ReactNode } from 'react';
import { PageHeader } from '../layout/PageHeader';

type PublicationPageHeaderProps = { title: string; actions: ReactNode };

export function PublicationPageHeader({ title, actions }: PublicationPageHeaderProps) {
    return (
        <PageHeader
            title={title}
            subtitle="Retrouvez l'ensemble de vos publications sur cette page"
            actions={actions}
        />
    );
}
